module.exports = __webpack_public_path__ + "img/entrance-1.31f11f2d.jpg";